<form [formGroup]="form">
  <div mat-dialog-actions>
    @if (data.mode === 'create') {
      <h1 mat-dialog-title>New cost override</h1>
    }
    @if (data.mode === 'edit') {
      <h1 mat-dialog-title>Edit cost override</h1>
    }
  </div>
  <mat-dialog-content flexLayout="row" flexLayoutGap="8px">
    <mat-form-field>
      <mat-label>Opinion Type</mat-label>
      <mat-select required [formControlName]="'caseTypeId'">
        @for (caseType of data.allCaseTypes | async; track trackByFn($index, caseType)) {
          <mat-option
            [value]="caseType.caseTypeId"
            >
            {{ caseType.displayName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions [attr.align]="'end'">
    <button mat-flat-button [mat-dialog-close]="{ save: false }">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      [mat-dialog-close]="{ save: true }"
      [disabled]="form.invalid"
      >
      Save
    </button>
  </mat-dialog-actions>
</form>
